<template>
  <div
    class="card clp-card hover-off"
    :class="{ 'for-compare': comparisionItems.includes(oferta.ofr.id) }"
  >
    <!-- <button
      @click="getUsunLink(oferta)"
      class="clp-card__remove"
      title="Usuń ze schowka"
    > -->
    <button
      @click="offerRemove(oferta)"
      class="clp-card__remove"
      title="Usuń ze schowka"
    >
      <span></span>
    </button>
    <div class="clp-card__thumbnail">
      <img
        :src="getUrl(oferta)"
        @error="onImageError"
        @load="hideLoader"
        :alt="oferta.ofr.obj.name"
      />
      <span class="image-loader">
        <loading-spinner :size="24" />
      </span>
    </div>

    <div class="clp-card__content p-12 p-sm-18">
      <div class="clp-card__header mr-sm-32">
        <div class="mb-6">
          <T1CardBreadcrumbs :items="getBreadcrumbs(oferta)" />
        </div>
        <h3 class="clp-card__hotel-name mb-2">{{ oferta.ofr.obj.name }}</h3>
        <T1Stars class="card__category" :number="oferta.ofr.obj.category" />
      </div>

      <div class="clp-card__details w-100">
        <div class="mb-18 mb-sm-0 pt-12">
          <T1TripDetails
            :dateFrom="formatData(oferta.ofr.trp.startDate)"
            :dateTo="formatData(oferta.ofr.trp.rDesDate)"
            :depDesc="oferta.ofr.trp.depDesc"
            :duration="oferta.ofr.trp.duration"
            :service="getWyzywienie(oferta.ofr.obj.xServiceId)"
            :touropName="getTourop(oferta.ofr.tourOp)"
            :type="oferta.ofr.type"
            class=""
            iconSize="14"
          />
        </div>
        <div class="clp-card__options">
          <a
            class="btn btn-yellow btn-md mb-18 w-100"
            :href="getUrlOfertaWithDomena(oferta)"
            :title="oferta.ofr.obj.name"
            rel="noopener"
            target="_blank"
            >Przejdź do oferty</a
          >
          <div class="clp-card__compare-checkbox">
            <label
              class="checkbox mb-0"
              :class="{
                disabled:
                  comparisionItems.length > 3 &&
                  !comparisionItems.includes(oferta.ofr.id),
              }"
            >
              <input
                @change="addToCompare(oferta)"
                v-model="checked"
                ref="addToCompareChceck"
                type="checkbox"
                :disabled="
                  comparisionItems.length > 3 &&
                  !comparisionItems.includes(oferta.ofr.id)
                    ? true
                    : false
                "
              />
              <span class="checkbox-inner"></span>
              <template
                v-if="
                  comparisionItems.length < 2 ||
                  !comparisionItems.includes(oferta.ofr.id) ||
                  isMobile
                "
              >
                <span class="label-txt">Dodaj do porównania</span>
              </template>
            </label>

            <template
              v-if="
                comparisionItems.length > 1 &&
                comparisionItems.includes(oferta.ofr.id) &&
                !isMobile
              "
            >
              <span class="pl-24">
                <a :href="comparisionLink" class="pl-2"
                  >Porównaj wybrane ({{ comparisionItems.length }})</a
                >
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tourop } from "../tourops.js";
import { wyzywienie } from "../wyzywienie.js";
import { domains } from "../domains.js";
import T1CardBreadcrumbs from "../T1Breadcrumbs/T1CardBreadcrumbs";
import T1Stars from "../T1Shared/T1Stars";
import T1TripDetails from "./T1TripDetails";

export default {
  name: "clipboard-offer-card",
  props: {
    oferta: Object,
    comparisionItems: Array,
    comparisionLink: String,
    isMobile: Boolean,
  },
  data: () => ({
    imageLoaded: false,
    tourop: tourop.tourops,
    wyzyw: wyzywienie.wyz,
    domeny: domains.countries,
    comparisons: [],
    checked: false,
  }),
  watch: {
    comparisionItems: function () {
      if (!this.comparisionItems.length) {
        this.checked = false;
      }
    },
  },
  methods: {
    addToCompare(oferta) {
      let ofid = oferta.ofr.id;
      this.$root.$emit("update:comparisons", ofid);
    },
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;

      if (loaderElem !== null) {
        loaderElem.classList.add("_hiding");

        setTimeout(() => {
          loaderElem.remove();
        }, 150);
      }
    },
    getBreadcrumbs(oferta) {
      let crumbsArr = [];

      if (
        (oferta.ofr.obj.type != "R" &&
          oferta.ofr.obj.region != "Wyc. objazdowe") ||
        oferta.ofr.obj.xCity != "Wyc. objazdowe"
      ) {
        if (typeof oferta.ofr.obj.country === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.country, link: "" });
        }
        if (typeof oferta.ofr.obj.region === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.region, link: "" });
        }
        if (
          typeof oferta.ofr.obj.xCity === "string" &&
          oferta.ofr.obj.xCity != oferta.ofr.obj.region &&
          oferta.ofr.obj.xCity != ""
        ) {
          crumbsArr.push({ name: oferta.ofr.obj.xCity, link: "" });
        }
      } else {
        crumbsArr.push({
          name: oferta.ofr.obj.country + ": wycieczki objazdowe",
          link: "",
        });
      }
      return crumbsArr;
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(6) +
          "." +
          data.substring(4, 6) +
          "." +
          data.substring(0, 4)
        );
      } else {
        return "";
      }
    },
    getUrl(oferta) {
      if (
        oferta.ofr &&
        oferta.ofr.datagourl !== undefined &&
        oferta.ofr.datagourl != ""
      ) {
        return "https://" + oferta.ofr.datagourl.replace(/T320/i, "T640");
      } else {
        return (
          "https://datacf.merlinx.eu/imgbycode/T640/" +
          oferta.ofr.tourOp +
          "-" +
          oferta.ofr.obj.code +
          "-0.jpeg"
        );
      }
    },
    // getUrlLocid(oferta) {
    //   if (oferta.ofr.hlocid != "") {
    //     return oferta.ofr.hlocid;
    //   } else {
    //     return "";
    //   }
    // },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getHref(hurl) {
      if (hurl != null && hurl != "") {
        return hurl;
      } else {
        return "/hotele/hotel.xml";
      }
    },
    getUrlDomena(oferta) {
      let ocountry = oferta.ofr.obj.country;
      if (ocountry != null && typeof ocountry === "string") {
        let lcountry = ocountry
          .replace(/\s+/g, "")
          .replace(/ą/g, "a")
          .replace(/ę/g, "e")
          .replace(/ś/g, "s")
          .replace(/ć/g, "c")
          .replace(/ń/g, "n")
          .replace(/ż/g, "z")
          .replace(/ź/g, "z")
          .replace(/ó/g, "o")
          .replace(/ł/g, "l")
          .replace(/Ą/g, "a")
          .replace(/Ę/g, "e")
          .replace(/Ś/g, "s")
          .replace(/Ć/g, "c")
          .replace(/Ń/g, "n")
          .replace(/Ż/g, "z")
          .replace(/Ź/g, "z")
          .replace(/Ó/g, "o")
          .replace(/Ł/g, "l")
          .toLowerCase();
        let elems = this.domeny.filter((e) => e.nazwa === lcountry);
        if (elems.length > 0) {
          return "https://www." + elems[0].domena;
        } else {
          return "https://www.travelone.pl";
        }
      } else {
        return "";
      }
    },
    getUrlOfertaWithDomena(oferta) {
      return this.getUrlDomena(oferta) + this.getUrlOferta(oferta);
    },
    offerRemove(oferta) {
      this.$emit("offerRemove", oferta);
    },
    // getUsunLink(oferta) {
    //   window.location =
    //     "https://www.travelone.pl/oferta/schowek.xml" +
    //     this.getUrlOferta(oferta, true) +
    //     "&oper=del";
    // },
    getUrlOferta(oferta, href) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        (href === undefined ? this.getHref(oferta.ofr.hurl) : "") +
        "?xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getTourop(tourop) {
      let tourOpName;
      if (tourop != null && tourop != "") {
        let items = this.tourop;
        items.forEach(function (obj) {
          if (obj.kod == tourop) {
            tourOpName = obj.nazwa;
          }
        });
        return tourOpName;
      } else {
        return "";
      }
    },
    onImageError(e) {
      e.target.src = "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    getDiscount(x, y) {
      return 100 - (x * 100) / y;
    },
    getMaxPrice(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        this.maxprice = oferta.ofr.extra.priceHistory.max;
      }
      return this.maxprice;
    },
    getDiscountPercentage(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        let price = oferta.ofr.price;
        let maxprice = oferta.ofr.extra.priceHistory.max;
        if (maxprice != price) {
          this.discount = Math.floor(
            this.getDiscount(Number(price), Number(maxprice))
          );
          return this.discount;
        }
      }
    },
  },
  components: {
    T1CardBreadcrumbs,
    T1Stars,
    T1TripDetails,
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1OfferCards/T1CardCommonStyles";

.clp-card {
  $self: &;

  &.for-compare {
    box-shadow: 0 0 1px 0px $blue-light;

    #{ $self }__content {
      border-color: $blue-light;
    }
  }

  @media (max-width: $screen-xs-max) {
    flex-direction: column;
  }

  &__remove {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    height: 48px;
    width: 48px;
    outline: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;

    > span {
      border-radius: 50%;
      display: block;
      margin: auto;
      height: 24px;
      width: 24px;
      position: relative;

      @media (max-width: $screen-xs-max) {
        background-color: rgba(#ffffff, 0.8);
      }

      &::after,
      &::before {
        background-color: $gray-70;
        content: "";
        position: absolute;
        top: 4px;
        right: 0;
        left: 0;
        margin: auto;
        width: 2px;
        height: 16px;
        transition: background-color ease-in-out 0.12s;
      }

      &::after {
        transform: rotate(45deg);
      }

      &::before {
        transform: rotate(-45deg);
      }
    }

    &:hover > span {
      &::after,
      &::before {
        background-color: red;
      }
    }
  }

  &__thumbnail {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 210px;
    width: 100%;
    overflow: hidden;
    position: relative;

    &::before {
      background-color: $gray-00;
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      transition: opacity linear 0.25s;
      z-index: 1;
    }

    &.__before-loaded {
      &::before {
        opacity: 1;
      }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
      backface-visibility: hidden;
      transform: translateZ(0);
    }
  }

  &__content {
    border-color: $border-color;
    border-style: solid;
    height: 100%;
    border-radius: 0 0 3px 3px;
    border-width: 0 1px 1px 1px;
    overflow: hidden;
    width: 100%;
    transition: border-color 0.1s ease-in-out;
  }

  &__hotel-name {
    font-size: 19px;

    > a {
      &,
      &:hover,
      &:focus {
        color: $text-color-default;
        text-decoration: none;
      }
    }
  }

  &__options {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
  }

  @media (max-width: $screen-xs-max) {
    &__content,
    &__details {
      display: flex;
      flex-direction: column;
    }

    &__details {
      height: 100%;
    }

    &__options {
      margin-top: auto;
    }
  }

  @media (min-width: $screen-sm) {
    &__thumbnail {
      height: 100%;
      width: 30vw;
    }

    &__content {
      border-radius: 0 3px 3px 0;
      border-width: 1px 1px 1px 0;
    }

    &__details {
      display: flex;
    }

    &__options {
      flex: 0 0 188px;
      max-width: 188px;
      margin-left: auto;
    }
  }

  @media (min-width: $screen-md) {
    &__thumbnail {
      width: 310px;
    }

    &__options {
      flex: 0 0 212px;
      max-width: 212px;
    }
  }

  &__compare-checkbox {
    @media (max-width: $screen-xs-max) {
      align-self: center;
    }

    align-self: flex-start;
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
